export default __webpack_public_path__ + "static/media/Medeata200blueSymbol.bdc634b7.svg";